import { render, staticRenderFns } from "./gold-list.vue?vue&type=template&id=9bc14aba&scoped=true"
import script from "./gold-list.vue?vue&type=script&lang=js"
export * from "./gold-list.vue?vue&type=script&lang=js"
import style0 from "./gold-list.vue?vue&type=style&index=0&id=9bc14aba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc14aba",
  null
  
)

export default component.exports